import { useState } from "react"
import { AuthFetch } from "../../services/api";
import { notify } from "../../utils/utils";

export const useReportes = () => {
    const [ rp01, setRp01 ] = useState([]);
    const [ rp02, setRp02 ] = useState([]);
    const [ rp02Transaccion, setRp02Transaccion ] = useState([]);
    const [ empresas, setEmpresas ] = useState([]);
    const [ rutas, setRutas ] = useState([]);
    const [ sentido, setSentido ] = useState([]);
    const [ rp03, setRp03 ] = useState([]);
    const [ recorridosPorLado, setRecorridosPorLado ] = useState([]);
    const [ dataControles, setDataControles ] = useState([]);
    const [ produccionPorControl, setProduccionPorControl ] = useState([]);
    const [ rp04, setRp04 ] = useState([])

    const listarRp01 = async (fechaInicio,fechaFin,codEstado) => {
        try{
            const response = await AuthFetch('/Report/atention?' + new URLSearchParams({
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin,
                    codEstado: codEstado
                }),
                {
                    method: 'GET'
                }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp01(response.isValid ? response.content : []);
        }
        catch(e){
            setRp01([]);
            notify('Ocurrió un error en el servicio','error');
        }
    }
    const listarRp02 = async (fechaInicio, fechaFin, codEmpresa) => {
        try {
            const response = await AuthFetch('/Report/executiveSummary?' + new URLSearchParams({
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin,
                    codEmpresa: 0
                }),
                { method: 'GET' }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp02(response.isValid ? response.content : []);
        } catch(e) {
            setRp02([]);
            notify('Ocurrió un error en el servicio al cargar el Reporte 2','error');
        }
    }

    const listarRp02Transaccion = async (fechaInicio, fechaFin, codEmpresa, codRuta) => {
        try {
            const response = await AuthFetch('/Report/TransactionsByCompanie?' + new URLSearchParams({
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin,
                    codEmpresa: codEmpresa,
                    codRuta: codRuta
                }),
                { method: 'GET' }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp02Transaccion(response.isValid ? response.content : []);
        } catch(e) {
            console.log('Error al listar rp02 transaccion → ',e)
            setRp02Transaccion([]);
            notify('Ocurrió un error en el servicio al cargar el Reporte 2','error');
        }
    }

    const comboEmpresas = async () => {
        try {
            const response = await AuthFetch('/Report/companies')
            if (response.isValid) {
                setEmpresas(response.content)
            }
        } catch (error) {
            notify('Ocurrió un error en el servicio al cargar el combo de empresas','error');
        }
    }

    const comboRutas = async (codEmpresa) => {
        try {
            const response = await AuthFetch('/Qr/routes?'+ new URLSearchParams({
                codEmpresa: codEmpresa
            }),
            { method: 'GET' }
        )
            if (response.isValid) {
                setRutas(response.content)
            }
        } catch (error) {
            notify('Ocurrió un error en el servicio al cargar el combo de rutas','error');
        }
    }

    const comboSentido = async (codEmpresa, codruta) => {
        try {
            const response = await AuthFetch('/Report/route?'+ new URLSearchParams({
                codEmpresa: codEmpresa,
                codruta: codruta
            }),
            { method: 'GET' }
        )
            if (response.isValid) {
                setSentido(response.content)
            }
        } catch (error) {
            notify('Ocurrió un error en el servicio al cargar el combo de rutas','error');
        }
    }
    const listarRp03 = async (codEmpresa, fechaInicio, fechaFin, codRecorrido) => {
        try {
            const response = await AuthFetch('/Report/stationProduction?' + new URLSearchParams({
                    codEmpresa: codEmpresa,
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin,
                    codRecorrido: codRecorrido
                }),
                { method: 'GET' }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp03(response.isValid ? response.content : []);
        } catch(e) {
            setRp03([]);
            notify('Ocurrió un error en el servicio al cargar el Reporte 2','error');
        }
    }

    const listarRecorridoPorLado = async (codEmpresa, codRuta, lado) => {
        try{
            const response = await AuthFetch('/Report/getPolylineFromPath?' + new URLSearchParams({
                    codEmpresa: codEmpresa,
                    codRuta: codRuta,
                    lado: lado
                }),
                { method: 'GET' }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRecorridosPorLado(response.isValid ? response.content : []);
            return response.isValid ? response.content : [];
        }
        catch(e){
            setRecorridosPorLado([])
            notify('Ocurrió un error en el servicio al cargar puntos recorridos','error');
            return [];
        }
    }

    const listarDataPorTipoConsulta = async (codEmpresa, fechaInicio, fechaFin, codRecorrido, codTipoConsulta, codTipoProduccion) => {
        try{
            const response = await AuthFetch('/Report/GetControl?' + new URLSearchParams({
                    codEmpresa: codEmpresa,
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin,
                    codRecorrido: codRecorrido,
                    codTipoConsulta: codTipoConsulta,
                    codTipoProduccion: codTipoProduccion
                }),
                { method: 'GET' }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            const nuevaData = response.isValid ? response.content : [];
            setDataControles(nuevaData);
            return nuevaData;
        }
        catch(e){
            setDataControles([])
            notify('Ocurrió un error en el servicio al cargar produccion','error');
            return []
        }
    }

    const listarProduccionPorControl = async (codEmpresa, fechaInicio, fechaFin, codRecorrido, codControl, codTipoConsulta, codTipoProduccion) => {
        try{
            const response = await AuthFetch('/Report/GetDetailByControl?' + new URLSearchParams({
                    codEmpresa: codEmpresa,
                    fechaInicio: fechaInicio,
                    fechaFin: fechaFin,
                    codRecorrido: codRecorrido,
                    codControl: codControl,
                    codTipoConsulta: codTipoConsulta,
                    codTipoProduccion: codTipoProduccion
                }),
                { method: 'GET' }
            )
            !response.isValid && notify(response.exceptions[0].description, 'error');
            return response.isValid ? response.content : [];
        }
        catch(e){
            notify('Ocurrió un error en el servicio al cargar produccion','error');
            return []
        }
    }

    const listarGestionRecarga = async (fechaInici, fechaFin, codRecargaTipo, modoRecarga) => {
        try{
            const response = await AuthFetch('/Report/RechargerManagement?' + new URLSearchParams({
                fechaInicio: fechaInici,
                fechaFin: fechaFin,
                codRecargaTipo: codRecargaTipo,
                modoRecarga: modoRecarga
            }))
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setRp04(response.isValid ? response.content : []);
        }
        catch(e){
            setRp04([])
            notify('Ocurrió un error en el servicio al cargar gestión de recargas','error');
            console.log('Error al listar la gestión de recargas: ',e)
        }

    }
    
    return{
        listarRp01,
        rp01,
        listarRp02,
        rp02,
        comboEmpresas,
        empresas,
        comboRutas,
        rutas,
        comboSentido,
        sentido,
        listarRp03,
        rp03,
        listarRecorridoPorLado,
        recorridosPorLado,
        listarDataPorTipoConsulta,
        dataControles,
        listarProduccionPorControl,
        produccionPorControl,
        listarGestionRecarga,
        rp04,
        listarRp02Transaccion,
        rp02Transaccion
    }
}